import axios from 'axios'
import { ref } from 'vue'

export function useFetchCMS() {
  const data = ref(null)
  const loading = ref(false)
  const error = ref(false)
  const cmsConfig = ref(process.env.CMS)

  const getCmsData = async (params) => {
    const { contentId, contentType } = params || {}

    loading.value = true
    data.value = null
    error.value = null
    try {
      const response = await axios.get(`${cmsConfig.value.domainURL}getcontent/block?id=${contentId}&type=${contentType}`)
      data.value = response.data
    } catch (err) {
      error.value = err
    }
    loading.value = false
  }

  return {
    data,
    loading,
    error,
    getCmsData,
    cmsConfig: cmsConfig.value
  }
}
